import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AudiotrackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"audiotrack"}/>
}
